import { Address } from '../store/model/address.model'

export const addressGenerator = (address?: Omit<Address, 'id'>) => {
  return address?.streetAddress ?
    `${address?.streetAddress || ''}. ${address?.city ? (address?.city + ',') : ''} ${address?.state || ''} ${address?.postalCode ? (address?.postalCode + '.') : ''} ${address?.country || ''}`
    : null
}